import {
  processLayoutOptions,
  PrimaryCollectionBlockType,
  LayoutOptions,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";
import { ContentCollectionItemType } from "@kameleon-section/content-collection-three-col-small-media-v1/types";

enum Alignment {
  left = "left",
  center = "center",
}

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...{
    alignment: LayoutOptions.Options(Alignment),
    itemBackground: LayoutOptions.Boolean,
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type ContentCollectionType = {
  /** Place prop documentation here */
  PrimaryBlocks: ContentCollectionItemType[];
} & PrimaryCollectionBlockType<LayoutProps>;
